module.exports = __webpack_public_path__ + "img/gartek-services-electrical-lighting-design.be58a604.png";